const PANEL_SELECTOR = '.header-with-search__suggestions-panel';
const SCROLLABLE_SELECTOR = '.header-with-search__suggestions';
const TRACK_SELECTOR = '.header-with-search__suggestions-scrollbar';
const THUMB_SELECTOR = '.header-with-search__suggestions-scrollbar-thumb';
const HIDDEN_CLASS = 'header-with-search__suggestions-scrollbar--hidden';
const MIN_THUMB_HEIGHT = 32;

function getScrollbarElements(panel: HTMLElement) {
  const scrollable = panel.querySelector<HTMLElement>(SCROLLABLE_SELECTOR);
  const track = panel.querySelector<HTMLElement>(TRACK_SELECTOR);
  const thumb = panel.querySelector<HTMLElement>(THUMB_SELECTOR);

  if (!scrollable || !track || !thumb) return null;

  return { scrollable, track, thumb };
}

export function updateSuggestionsScrollbar(panel: HTMLElement): void {
  const elements = getScrollbarElements(panel);
  if (!elements) return;

  const { scrollable, track, thumb } = elements;
  const { scrollHeight, clientHeight, scrollTop } = scrollable;
  const hasOverflow = scrollHeight > clientHeight + 1;

  track.classList.toggle(HIDDEN_CLASS, !hasOverflow);

  if (!hasOverflow) {
    thumb.style.height = '';
    thumb.style.transform = '';
    return;
  }

  const trackHeight = track.clientHeight;
  const thumbHeight = Math.max((clientHeight / scrollHeight) * trackHeight, MIN_THUMB_HEIGHT);
  const maxThumbOffset = trackHeight - thumbHeight;
  const scrollableDistance = scrollHeight - clientHeight;
  const thumbOffset = scrollableDistance > 0 ? (scrollTop / scrollableDistance) * maxThumbOffset : 0;

  thumb.style.height = `${thumbHeight}px`;
  thumb.style.transform = `translateY(${thumbOffset}px)`;
}

export function initSuggestionsScrollbar(panel: HTMLElement): void {
  const elements = getScrollbarElements(panel);
  if (!elements) return;

  const { scrollable } = elements;

  if (panel.dataset.suggestionsScrollbarInit === 'true') {
    updateSuggestionsScrollbar(panel);
    return;
  }

  panel.dataset.suggestionsScrollbarInit = 'true';

  scrollable.addEventListener('scroll', () => updateSuggestionsScrollbar(panel), { passive: true });

  if (typeof window.ResizeObserver !== 'undefined') {
    const resizeObserver = new window.ResizeObserver(() => updateSuggestionsScrollbar(panel));
    resizeObserver.observe(scrollable);
    resizeObserver.observe(panel);
  }

  updateSuggestionsScrollbar(panel);
}

export function initAllSuggestionsScrollbars(root: ParentNode = document): void {
  root.querySelectorAll<HTMLElement>(PANEL_SELECTOR).forEach(initSuggestionsScrollbar);
}
